module.exports = __webpack_public_path__ + "img/Frame-59.77c04c8e.svg";